import { render, staticRenderFns } from "./InstagramPost.vue?vue&type=template&id=f0502f64&"
import script from "./InstagramPost.vue?vue&type=script&lang=js&"
export * from "./InstagramPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports